export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8400.743e2c87.jpg";